export default __webpack_public_path__ + "static/media/guia-mobile-1.d783eb51.png";